import { useDispatch } from 'react-redux';
import useOnMount from 'hooks/useOnMount';
import { getMyAnnouncements } from 'redux/modules/announcement/actions';
import { clearPodcastFeed } from 'redux/modules/automation-cms';
import { getMyDisplayPref } from 'redux/modules/display-pref';
import { clearEmbedExport } from 'redux/modules/embed-export/actions';
import { clearProjectHistory } from 'redux/modules/project/actions';
import useOpenEditAutomationModalFromURL from './useOpenEditAutomationModalFromURL';

export default function useOnProjectsPageMount() {
  const dispatch = useDispatch();

  useOpenEditAutomationModalFromURL();

  useOnMount(
    () => {
      dispatch(clearEmbedExport());
      dispatch(getMyDisplayPref());
      dispatch(getMyAnnouncements());
    },
    () => {
      dispatch(clearProjectHistory());
      dispatch(clearPodcastFeed());
    },
  );
}
